import { render } from "./ChooseGroup.vue?vue&type=template&id=082d51a2"
import script from "./ChooseGroup.vue?vue&type=script&lang=js"
export * from "./ChooseGroup.vue?vue&type=script&lang=js"
script.render = render

export default script